import apple from "../../../assets/apple-logo.png";
import google from "../../../assets/google-play.png";
import agent from "../../../assets/agent-hero.png";

const HeroSection = () => {
  return (
    <div className="max-lg:px-6 lg:ml-16 py-14 lg:py-10">
      <div className="lg:grid grid-cols-2 gap-8">
        <div className="flex items-center">
          <div>
            <h1 className="text-3xl leading-[42.3px] lg:text-6xl lg:leading-[81px] font-semibold text-primary">
              Revolutionize the logistics industry by joining ZAP's team of
              skilled drivers.
            </h1>
            <div className="lg:max-w-[350px] flex items-center space-x-5 mt-7">
              <div className="download-btn">
                <div className="w-5 sm:w-7">
                  <img className="w-full" alt="" src={apple} />
                </div>
                <div>
                  <span className="text-xs text-paragraph">
                    Download on the
                  </span>
                  <h1 className="max-sm:text-xs font-medium text-primaryBlack -mt-1">
                    App Store
                  </h1>
                </div>
              </div>
              <div className="download-btn">
                <div className="w-5 sm:w-7">
                  <img className="w-full" alt="" src={google} />
                </div>
                <div>
                  <span className="text-xs text-paragraph">Get it on</span>
                  <h1 className="max-sm:text-xs font-medium text-primaryBlack -mt-1">
                    Google Play
                  </h1>
                </div>
              </div>
            </div>
            <div className="mt-5 text-2xl lg:text-2xl font-semibold text-primary hover:cursor-pointer">
              <h1>Watch video</h1>
            </div>
          </div>
        </div>
        <div className="max-lg:max-w-[60%] max-lg:mx-auto max-lg:my-9 max-w-[80%]">
          <img src={agent} alt="" />
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
